import { render, staticRenderFns } from "./feedGroup.vue?vue&type=template&id=ff248372&scoped=true&"
import script from "./feedGroup.vue?vue&type=script&lang=js&"
export * from "./feedGroup.vue?vue&type=script&lang=js&"
import style0 from "./feedGroup.vue?vue&type=style&index=0&id=ff248372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff248372",
  null
  
)

export default component.exports